"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = reducer;
exports.isLoaded = isLoaded;
exports.isEmpty = isEmpty;
exports.middleware = middleware;

var _firebase = require("firebase");

var _firebase2 = _interopRequireDefault(_firebase);

var _util = require("./util");

var Util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { isLoaded: false };
  var action = arguments[1];

  switch (action.type) {
    case "AUTH_STATE_CHANGED":
      return { isLoaded: true, isEmpty: action.isEmpty };
    default:
      return state;
  }
}

function isLoaded(state) {
  return state.firebaseAuthLoaded.isLoaded;
}
function isEmpty(state) {
  return state.firebaseAuthLoaded.isEmpty;
}

// react-redux-firebase doesn't return auth status accurately, so do it manually.
function middleware(store) {
  // react-redux-firebase doesn't correctly report when auth's loaded if the user's not logged in, so do it manually
  _firebase2.default.auth().onAuthStateChanged(function (user) {
    return store.dispatch({ type: "AUTH_STATE_CHANGED", isEmpty: !user });
  });
  return function (next) {
    return function (action) {
      return next(action);
    };
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/auth-loaded.js
// module id = 218
// module chunks = 0